<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="w-100 breadCrumbsWrapper">
            <BreadCrumbsHeader :mainTitle="'VOD'" :currentPage="'VOD'" />
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid px-0 px-md-2 overflow-hidden">
      <VodMasthead />
      <CategoryCarousel :obj="categories" :cat_id="categories_id" />
      <!-- <VodCovidrails />
      <VodCovidPreventionRails /> -->

      <!-- ads -->
      <div class="w-100 my-3">
        <billboardBannerTop v-if="desktop"></billboardBannerTop>
        <mrecBannerTop v-if="mobile"></mrecBannerTop>
      </div>

      <div
        class="w-100 my-2"
        v-for="(items, index) in categories_id"
        :key="'cat_id' + items"
      >
        <VodRailsLandscapeNew
          :cat_id="items"
          :datasource="'vod'"
          :cat="convertStringToLower(categories[index].replace(/\s/g, ''))"
          :title="categories[index]"
          v-if="index !== 7"
        />
        <div class="w-100" v-if="index == 4">
          <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
          <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>
        </div>
      </div>

      <!-- ads -->
      <!-- <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
      <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle> -->

      <!-- ads bottom -->
      <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
      <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from "../assets/noimage.png";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
// ads
import billboardBannerTop from "../components/ads/billboardBannerTop";
import mrecBannerTop from "../components/ads/mrecBannerTop";
import billboardBannerMiddle from "../components/ads/billboardBannerMiddle";
import mrecBannerMiddle from "../components/ads/mrecBannerMiddle";
import BillboardBannerBottom from "../components/ads/billboardBannerBottom";
import MrecBannerBottom from "../components/ads/mrecBannerBottom";
import VodMasthead from "../components/carousel/vodMasthead.vue";
import CategoryCarousel from "../components/categoryCarousel.vue";
// import VodCovidrails from "../components/carousel/vod/vodCovidrails.vue";
// import VodCovidPreventionRails from "../components/carousel/vod/vodCovidPreventionRails.vue";
import VodRailsLandscapeNew from "../components/rails/vod_rails_landscape_new.vue";
export default {
  data: function() {
    return {
      vod: [],
      vod_mnn: [],
      vod_each: [],
      news: [],
      specials: [],
      trending: [],
      vod_episodes: [],
      noimage: noimage,
      mnnlink: "/play?scheme=205&p_type=true&id=1387&eps_id=",
      SpecialRailsId: "1387",
      SpecialRailsTitle: "COVID-19: MOH Press Conference",
      showvod_mnn: true,
      categories: [
        // "Covid-19",
        "Recommended",
        "News",
        "Exclusives",
        "Catch Up",
        "Documentary",
        "Drama",
        "Education",
        "Entertainment",
        "Magazine",
        "Nostalgia",
        "Religious",
        "Variety",
      ],
      categories_id: [
        // "846",
        "943", //kt sini festival
        "212",
        "716",
        "746",
        "703",
        "728",
        "740",
        "717",
        "715",
        "749",
        "718",
        "726",
      ],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  components: {
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    BreadCrumbsHeader,
    VodMasthead,
    CategoryCarousel,
    // VodCovidrails,
    VodRailsLandscapeNew,
    // VodCovidPreventionRails,
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 2,
            stagePadding: 0,
            loop: false,
          },
          991: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    installTrendingOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          991: {
            items: 3,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/500x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/500x0/" +
            item.data.images.title.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    goTo(link) {
      this.$router.push(link);
    },
    goToBanner(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      }

      return link;
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    filterBasedOnCategory() {
      var obj = this.vod;
      var categories = this.categories;
      var each = {};
      // this.vod_each;
      obj.forEach((items) => {
        var content_type = items.data.content_type;

        if (content_type.length != 0) {
          content_type.forEach((items_cat) => {
            for (var i = 0; i < categories.length; i++) {
              if (
                items_cat.title.en_US === categories[i] ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i]) ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i].replace(/\s/g, ""))
              ) {
                // console.log(this.convertStringToLower(categories[i].replace(/\s/g, "")));
                if (
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ]
                ) {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ].push(items);
                } else {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ] = [items];
                }
              }
            }
          });
        }
      });
      this.vod_each.push(each);
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    initializepageview() {
      var self = this;
      // console.log(this.$route.path);
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: this.$route.path,
          title: "vod",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },

  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 90px 0 0;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
